<template>
	<base-form-dialog
		ref="refBaseCard"
		formOptionNumTemp="7"
		is-form
		is-show-close
		title="身份证识别"
		width="35%"
		@onSendFileList="onGetFileList"
		@onUploadAfter="onUploadAfter"></base-form-dialog>
</template>

<script>
import BaseFormDialog from '@/components/insurance/baseFormDialog.vue'

import {uploadIdNoImg} from '@/api/insurance/policy'
import {addIdNoQuery} from 'meibao-insure/src/api/productCenterNew'

export default {
	name: 'cardDialog',
	components: {BaseFormDialog},
	data() {
		return {
			addIdNoInterval: null,
			//查询次数
			queryCount: 0,
		}
	},
	beforeDestroy() {
		this.onClearShowHint()
	},
	methods: {
		show() {
			this.$refs['refBaseCard'].show()
		},
		onUploadAfter(res = {}, done, loading) {},
		async onGetFileList(fileList) {
			//调用接口
			let formData = new FormData()

			for (let fileListElement of fileList) {
				formData.append('files', fileListElement)
			}
			formData.append('side', 'face')
			formData.append('idName', '')
			formData.append('batchld', '0')

			//清空fileList
			this.$refs.refBaseCard.onClearFileList()
			let uploadResult = (await uploadIdNoImg(formData)) || {}
			console.log('uploadResult---', uploadResult)

			let {code = -1, data = {}} = uploadResult.data
			if (code === 0) {
				//需要循环识别数据
				let {batchId = ''} = data
				this.onGetIdNo(batchId)
			}
		},
		onGetIdNo(batchId = '') {
			//循环调用获取身份证数据
			this.addIdNoInterval = setInterval(async () => {
				try {
					if (this.queryCount >= 10) {
						this.onClearShowHint('身份证图片识别超时，请检查后再重新上传！')
						done()
						return
					}
					this.queryCount++
					let resultAdd = (await addIdNoQuery(batchId)) || {}
					let {
						code: code1 = -1,
						data: {emps = []},
						msg: msg1 = '',
					} = resultAdd.data
					if (code1 === 0 && emps.length > 0) {
						let tempIndex = emps.findIndex(({code: code2}) => code2 === '100')
						if (tempIndex === -1) {
							this.onClearShowHint()
							// 所有数据都识别完成
							let sendData = []
							for (let empItemData of emps) {
								if (empItemData.code === '200' || empItemData.code === '0') {
									sendData.push(empItemData)
								}
							}
							//发送数据
							console.log('sendData-----', sendData)
							if (sendData.length > 0) {
								this.$emit('onCardSuccess', sendData)
							}
							await this.$alert(
								`识别结果：成功识别${sendData.length}条，失败${emps.length - sendData.length}条`,
								'提示',
							)
						}
					} else {
						//请求错误
						this.onClearShowHint(msg1)
					}
				} catch (error) {}
			}, 1200)
		},
		//提示错误
		onClearShowHint(content = '') {
			this.$refs.refBaseCard.isShowFormLoading(false)
			this.queryCount = 0
			if (this.addIdNoInterval) {
				clearInterval(this.addIdNoInterval)
				this.addIdNoInterval = null
			}
			if (content) {
				this.$alert(content, '提示')
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
	margin-left: 0 !important;
}

::v-deep .el-dialog--center .el-dialog__body {
	text-align: center;
}
</style>
